"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isColor = exports.getAlpha = exports.toRgb = void 0;
const color_1 = __importDefault(require("color"));
/**
 * @param value - a color represented as a string (hex, rgb, rgba, hsl, hsla, etc)
 * @return the color represented as its rgb values with alpha channel stripped
 */
const toRgb = (value) => {
    const [r, g, b] = (0, color_1.default)(value).rgb().array();
    return `${r} ${g} ${b}`;
};
exports.toRgb = toRgb;
/**
 * @param value - a color represented as a string (hex, rgb, rgba, hsl, hsla, etc)
 * @return the alpha channel of the color
 */
const getAlpha = (value) => {
    return (0, color_1.default)(value).alpha();
};
exports.getAlpha = getAlpha;
/**
 * @param value - the value to test if it is a valid color string
 * @return whether the value passed in is a valid color string
 */
const isColor = (value) => {
    if (typeof value === 'number') {
        return false;
    }
    try {
        (0, color_1.default)(value);
        return true;
    }
    catch {
        return false;
    }
};
exports.isColor = isColor;
